module.exports = __webpack_public_path__ + "static/media/04-galeria-03-santa-fe@2x.7a30edfb.jpg";